
export default function About() {
  const pillars = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Experiência',
      description: 'Longa trajetória no mercado financeiro e de serviços com resultados comprovados'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Foco',
      description: 'Dedicação total aos projetos e investimentos, garantindo excelência na execução'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Disciplina',
      description: 'Processos rigorosos e metodologia consistente em todas as nossas operações'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Sobre a Selem&Selem
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            A Selem&Selem Participações é uma companhia de investimentos e consultoria estratégica especializada na alocação de recursos na economia real, combinando longa experiência do mercado financeiro e de serviços à comprovada capacidade de execução.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {pillars.map((pillar, index) => (
            <div key={index} className="bg-slate-50 rounded-xl p-8 hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${pillar.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4 text-center">{pillar.title}</h3>
              <p className="text-slate-600 text-center leading-relaxed">{pillar.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-slate-800 via-slate-900 to-teal-900 rounded-2xl p-12 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
          </div>
          <div className="relative z-10">
            <div className="max-w-3xl mx-auto text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-teal-600/20 rounded-2xl mb-6">
                <i className="ri-building-line text-4xl text-teal-400"></i>
              </div>
              <h3 className="text-3xl font-bold text-white mb-6">
                A Origem do Nome SELEM
              </h3>
              <p className="text-slate-300 leading-relaxed mb-4">
                O nome SELEM tem origem na 3ª geração do fundador Ricardo Manhães que imigraram para o Brasil em 1916 para aqui se estabelecerem como comerciantes do varejo alimentar e agroindústria.
              </p>
              <p className="text-slate-300 leading-relaxed">
                Por sua visão, persistência e valores, teve seu nome homenageado na fundação da empresa, perpetuando um legado de empreendedorismo e dedicação.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-4xl font-bold text-teal-400 mb-2">1916</div>
                <div className="text-slate-300 text-sm">Chegada ao Brasil</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-4xl font-bold text-teal-400 mb-2">3ª</div>
                <div className="text-slate-300 text-sm">Geração</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-4xl font-bold text-teal-400 mb-2">100+</div>
                <div className="text-slate-300 text-sm">Anos de Legado</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 text-center">
          <h3 className="text-3xl font-bold text-slate-800 mb-6">
            Construindo Histórias de Sucesso
          </h3>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            A Selem&Selem realizou e tem entre seus investimentos e projetos diferentes setores da economia brasileira, entre os quais <strong>Fidelidade</strong>, <strong>Incentivos</strong>, <strong>Serviços</strong> e <strong>Tecnologia</strong>.
          </p>
        </div>

        <div className="mt-16 bg-teal-600 rounded-2xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <i className="ri-team-line text-6xl text-white mb-6"></i>
            <h3 className="text-3xl font-bold text-white mb-4">
              Pessoas - Nosso Maior Capital
            </h3>
            <p className="text-xl text-white/90 leading-relaxed">
              A Selem&Selem sempre acreditou e acreditará que pessoas movem o mundo em busca do sucesso de cada projeto.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
